import { Outlet } from 'react-router-dom'
import { env } from '@/app/config/env'

/** Centred card layout for login and tenant selection. */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex size-10 items-center justify-center rounded-lg bg-accent text-sm font-semibold text-accent-fg">
            TF
          </div>
          <h1 className="text-lg font-semibold text-fg">{env.appName}</h1>
          <p className="mt-0.5 text-sm text-fg-muted">
            Inspection operations and administration
          </p>
        </div>
        <div className="rounded-xl border border-border bg-surface p-5 shadow-sm">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
